export class PlantillaModel {
  _id:string;
  nombre:string = "";
  descripcion:string = "";
  activo:boolean = true;

  // lista de ids
  catActivas:any[] = [];
  subcatActivas:any[] = [];
  pregActivas:any[] = [];

  toString(){
    return {
      nombre:this.nombre,
      descripcion:this.descripcion,
      catActivas:this.catActivas,
      subcatActivas:this.subcatActivas,
      pregActivas:this.pregActivas,
      activo:this.activo
    }
  }
}
